export default __webpack_public_path__ + "static/apple_logo-a411bc45f07352f5e922a36f5ba2c895.svg";